import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import UserDetailCard from "../../components/UserDetailCard";
import AdminActions from "../../components/AdminActions";
import UserProgressBarDetail from "../../components/UserProgressBarDetail";
import { userDetailApplications } from "../../components/UserManagementData";
import { userService } from "../../services/userService";
import helpers from "../../utils/helpers";

function UserManageEducator({permission}) {
  const [reportVisibility, setReportVisibility] = useState(true);
  const [piiSafe, setPiiSafe] = useState(true);
  const [user, setUser] = useState(null); // store educator details
  const [students, setStudents] = useState(null); // store educator detailst
  const [application, setApplication] = useState(null)
  


  const { id } = useParams(); // ✅ get ID from route params

  let decryptId = helpers.decryptId(id)

const fetchUserDetails = async (userId) => {
  try {
    const res = await userService.getUserById(userId);
    console.log("Fetched user details:", res.applications);
    setUser(res.user);
    setStudents(res.students)
    setApplication(res.applications)
    
  } catch (error) {
    console.error("Error fetching user details:", error);
  }
};

useEffect(() => {
  if (decryptId) {
    fetchUserDetails(decryptId);
  }
}, [decryptId]);
console.log(application, 'application insdsddsd')

  return (
    <div className="my-5">
      <div className="grid grid-cols-12 gap-6">
        {/* Left column (col-4) */}
        <div className="col-span-12 md:col-span-4 space-y-4">
          <div>
            <UserDetailCard role="Educator" user={user} />
          </div>
          <div>
            <AdminActions userId={id} permission={permission}/>
          </div>
        </div>

        {/* Right column (col-8) */}
        <div className="col-span-12 md:col-span-8">
          {/* Data Access Section */}
          <div className="card rounded-2xl p-5 mb-5">
            <div className="card-body">
              <h3 className="text-secondary-800 font-medium mb-4">Data Access</h3>
              <div className="flex items-center gap-10 p-5">
                {/* Report Visibility */}
                <label className="flex items-center gap-2 cursor-pointer text-secondary-700">
                  <input
                    type="checkbox"
                    checked={reportVisibility}
                    onChange={() => setReportVisibility(!reportVisibility)}
                    className="w-5 h-5 text-primary-400 border-gray-100 rounded focus:ring-primary-500"
                  />
                  Report Visibility
                </label>

                {/* PII-Safe Datasets */}
                <label className="flex items-center gap-2 cursor-pointer text-secondary-700">
                  <input
                    type="checkbox"
                    checked={piiSafe}
                    onChange={() => setPiiSafe(!piiSafe)}
                    className="w-5 h-5 text-primary-400 border-gray-100 rounded focus:ring-primary-500"
                  />
                  PII-Safe Datasets
                </label>
              </div>
            </div>
          </div>

          {/* User Progress Section */}
          <div className="card">
            <div className="card-body p-4">
              <UserProgressBarDetail application={application} students={students}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserManageEducator;
